/* eslint-disable react-hooks/exhaustive-deps */
import {FC, useContext, useState, useEffect, useMemo} from 'react'
import {useQuery} from 'react-query'
import {
    createResponseContext,
    initialQueryResponse,
    initialQueryState,
    PaginationState,    
    stringifyRequestQuery,
    WithChildren,
    Response
} from '../../../../../_metronic/helpers'

import { getDLMApplications, getAllDLMApplications } from '../_requests'
import { DLMApplicationsListItem } from '../_models'
import { useDLMApplicationQueryRequest } from './DLMApplicationQueryRequestProvider'
import { useAuth } from '../../../auth'
import { useLocation } from 'react-router-dom'



const DLMApplicationQueryResponseContext = createResponseContext<DLMApplicationsListItem>(initialQueryResponse)
const DLMApplicationQueryResponseProvider: FC<WithChildren> = ({children}) => {
    const {state} = useDLMApplicationQueryRequest()
    const {currentUser} = useAuth();

    const [query, setQuery] = useState<string>(stringifyRequestQuery(state))
    const updatedQuery = useMemo(() => stringifyRequestQuery(state), [state])

    const { listmode } = state;

    const location = useLocation();    

    const lastpath = useMemo(() => {
        if (! (location && location.pathname)) return '';
        return location.pathname.split('/').pop();
    }, [location]);

    useEffect(() => {        
        if (query !== updatedQuery) {
            setQuery(updatedQuery)
        }
    }, [updatedQuery])

    const {
        isFetching,
        refetch,
        data: response,
    } = useQuery(
        ['DLMAPPLICATIONS-LIST', { lastpath, listmode }],        
        // @ts-ignore
        () => {               
            if (currentUser && currentUser.role === 'System Admin') {
                // dummy response for 'System Admin' only accounts
                return Promise.resolve().then(() => {
                    return {data : [] , payload : {}};
                })
            } else if (listmode === 'all') {
                return getAllDLMApplications(lastpath);
            } else { 
                return getDLMApplications(lastpath);
            }            
        },
        {cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false}
    )

    return (
    <DLMApplicationQueryResponseContext.Provider value={{isLoading: isFetching, refetch, response, query}}>
        {children}
    </DLMApplicationQueryResponseContext.Provider>
    )
}

const useDLMApplicationQueryResponse = () => useContext(DLMApplicationQueryResponseContext)

const useDLMApplicationQueryResponseData = () => {
    const {response} = useDLMApplicationQueryResponse()
    if (!response) {
        return []
    }

    return response?.data || []
}

const useDLMApplicationQueryResponsePagination = () => {
    const defaultPaginationState: PaginationState = {
        links: [],
        ...initialQueryState,
    }

  const {response} = useDLMApplicationQueryResponse()
    if (!response || !response.payload || !response.payload.pagination) {
        return defaultPaginationState
    }

    return response.payload.pagination
}

const useDLMApplicationQueryResponseLoading = (): boolean => {
  const {isLoading} = useDLMApplicationQueryResponse()
  return isLoading
}

export {
    DLMApplicationQueryResponseProvider,
    useDLMApplicationQueryResponse,
    useDLMApplicationQueryResponseData,
    useDLMApplicationQueryResponsePagination,
    useDLMApplicationQueryResponseLoading,    
}

export type DLMApplicationsQueryResponse = Response<Array<DLMApplicationsListItem>>